import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';

var useDividerStyle = function useDividerStyle(_ref) {
  var labelPosition = _ref.labelPosition;
  return {
    label: {
      fontFamily: 'inherit',
      color: 'var(--gui-color-text-2)!important',
      fontSize: '14px',
      fontWeight: 400,
      '&:before': _objectSpread2(_objectSpread2({}, labelPosition === 'left' ? {
        width: '24px',
        flex: 'initial'
      } : {}), {}, {
        marginRight: '8px'
      }),
      '&:after': _objectSpread2(_objectSpread2({}, labelPosition === 'right' ? {
        width: '24px',
        flex: 'initial'
      } : {}), {}, {
        marginLeft: '8px'
      })
    }
  };
};

export { useDividerStyle };
//# sourceMappingURL=Divider.style.js.map
